(function () {
    'use strict';

    angular
        .module('franchisee.components')
        .controller('UnitFormController', UnitFormController)

    /** @ngInject */
    function UnitFormController($scope, $rootScope, $q, $state, AuthenticationService, HelperService, ClusterService, EconomicGroupService, PersonService, UnitService, CityService, StateService, sweetAlert, DATA_EVENTS) {
        const vm = this;

        let galleryUploadedImages = [];
        let unitOriginalWorkingTime = [];

        // SYSTEM DEFAULT METHODS
        // vm.uiCanExit = () => {
        //     return HelperService.uiCanExit(unitOriginalWorkingTime, vm.workingTimes);
        // }

        // vm.isDataModified = () => {
        //     return !angular.equals(vm.workingTimes, unitOriginalWorkingTime);
        // }

        // vm.resetForm = () => {
        //     angular.copy(unitOriginalWorkingTime, vm.workingTimes);
        // }

        // Main image
        vm.flowFileAdded = ($file, isGallery = false) => {
            let blacklist = ['png', 'gif', 'jpg', 'jpeg'];
            let extension = $file.getExtension();

            let form = '.image';

            if (isGallery) {
                form = '.gallery';
            }

            if (!blacklist.includes(extension)) {
                HelperService.setErrorMessageForm(form, 'Formato inválido.', true);
                return false;
            }

            vm.oldFormImageMain = vm.mainImageData.Url;

            if (!isGallery)
                HelperService.startLoading('.image-loading-holder');

            HelperService.removeErrorMessageForm(form);
        }

        vm.flowFileFinishedMain = ($file, $message) => {
            var message = angular.fromJson($message);

            vm.mainImageData.Url = message.FileSaveName;
            vm.mainImageData.Display = HelperService.imageHandlerPath('unit', vm.unitData.Id, message.FileSaveName);

            let imageData = {
                UnitId: vm.unitData.Id,
                Main: true,
                Url: vm.mainImageData.Url,
                Description: ''
            }

            vm.saveImage(imageData);
        }

        // Gallery
        vm.flowFileFinishedGallery = ($file, $message, $flow) => {
            let message = angular.fromJson($message);

            message.uniqueIdentifier = $file.uniqueIdentifier;

            galleryUploadedImages.push(message)

            if (galleryUploadedImages.length == $flow.files.length) {
                $flow.files = [];

                let uploadPromisses = [];

                for (let index = 0; index < galleryUploadedImages.length; index++) {
                    const imageUpload = galleryUploadedImages[index];

                    let imageData = {
                        UnitId: vm.unitData.Id,
                        Main: false,
                        Url: imageUpload.FileSaveName,
                        Description: ''
                    }

                    uploadPromisses.push(vm.saveImage(imageData, imageUpload.uniqueIdentifier, false));
                }

                galleryUploadedImages = [];

                HelperService.startLoading('.image-loading-holder');

                $q.all(uploadPromisses)
                    .then(success => {
                        HelperService.successCallback();
                        HelperService.stopLoading('.image-loading-holder');
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.image-loading-holder');
                    })
            }
        }

        // On error in upload
        vm.flowFileError = $flow => {
            $flow.files = [];

            NotifyService.error('Não foi possível salvar a imagem.');
            HelperService.stopLoading('.image-loading-holder');
            HelperService.stopLoading('.loading-holder');
        }

        vm.saveImage = (imageData, fileIdentifier, showLoading = true) => {
            if (showLoading)
                HelperService.startLoading('.image-loading-holder');

            return UnitService
                .postImage(imageData)
                .then(success => {
                    if (!imageData.Main) {
                        success.fullPath = HelperService.imageHandlerPath('unit', vm.unitData.Id, imageData.Url);

                        vm.unitGallery.push(success);

                        $('#' + fileIdentifier).remove();
                    }

                    if (showLoading) {
                        HelperService.stopLoading('.image-loading-holder');
                        HelperService.successCallback();
                    }
                }, error => {
                    if (showLoading) {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.image-loading-holder');
                    }
                })
        }

        vm.updateImage = imageData => {
            HelperService.startLoading('.image-loading-holder');

            UnitService
                .putImage(imageData)
                .then(success => {
                    HelperService.stopLoading('.image-loading-holder');
                    HelperService.successCallback();
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.image-loading-holder');
                })
        }

        vm.deleteImage = imageData => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.image-loading-holder');

                    UnitService
                        .deleteImage(imageData.Id)
                        .then(() => {
                            if (!imageData.Main) {
                                var index = vm.unitGallery.indexOf(imageData);

                                if (index !== -1)
                                    vm.unitGallery.splice(index, 1);
                            } else {
                                vm.mainImageData = {
                                    Url: '',
                                    Display: ''
                                }

                                if (vm.flowScopeMain.flow.files.length)
                                    vm.flowScopeMain.flow.files[0].cancel();
                            }

                            HelperService.stopLoading('.image-loading-holder');
                            HelperService.successCallback('delete');
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.image-loading-holder');
                        })
                }
            })
        }

        vm.changeTab = tabId => {
            vm.selectedTab = tabId;
        }

        // Data
        vm.getCities = preSelectedCityId => {
            delete vm.selectedCity;

            vm.cities = [];
            vm.cityPlaceholder = 'AGUARDE...';

            CityService
                .getByState(vm.selectedState.Id)
                .then(success => {
                    if (!success.length)
                        vm.cityPlaceholder = 'NENHUM RESULTADO';
                    else
                        vm.cityPlaceholder = 'ESCOLHA A CIDADE';

                    vm.cities = success;

                    if (preSelectedCityId)
                        vm.selectedCity = vm.cities.find(city => (city.Id == preSelectedCityId));
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        // Unit working time
        vm.getWeekDayWorkingTime = weekDay => {
            return vm.workingTimes.find(wt => wt.WeekDayId == weekDay.Id);
        }

        vm.saveWorkingTime = () => {
            HelperService.startLoading('.loading-holder');

            vm.workingTimes.forEach(time => {
                if (time.Closed || (!time.Closed && (time.StartHourId == null || time.EndHourId == null))) {
                    time.StartHourId = null;
                    time.EndHourId = null;
                    time.Closed = true;
                }
            })

            if (vm.workingTimes[0].Id) {
                UnitService
                    .putWorkingTime(vm.workingTimes)
                    .then(success => {
                        vm.workingTimes = success;

                        angular.copy(vm.workingTimes, unitOriginalWorkingTime);

                        HelperService.stopLoading('.loading-holder');
                        HelperService.successCallback('update');
                    }, error => {
                        HelperService.stopLoading('.loading-holder');
                        HelperService.errorCallback(error);
                    })
            } else {
                UnitService
                    .postWorkingTime(vm.workingTimes)
                    .then(success => {
                        vm.workingTimes = success;

                        angular.copy(vm.workingTimes, unitOriginalWorkingTime);

                        HelperService.stopLoading('.loading-holder');
                        HelperService.successCallback();
                    }, error => {
                        HelperService.stopLoading('.loading-holder');
                        HelperService.errorCallback(error);
                    })
            }
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            HelperService.startLoading('.loading-holder');

            initVars();
            getUnit();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        // Unit working time
        function getHours() {
            return UnitService
                .getHours()
                .then(
                    success => {
                        let hours = success.filter(x => x.Active);

                        hours.forEach(hour => {
                            hour.momentHour = moment()
                                .hours(hour.Horary.substring(0, 2))
                                .minutes(hour.Horary.substring(3, 5))
                        });

                        vm.hours = hours;
                    }, error => HelperService.errorCallback(error)
                );
        }

        function prepareWorkingTimeWeek() {
            const unitId = vm.unitData.Id;

            for (let index = 0; index < vm.weekDays.length; index++) {
                let weekDay = vm.weekDays[index];
                let workingTime = vm.workingTimes.find(wt => wt.WeekDayId == weekDay.Id);

                if (!workingTime) {
                    let newWorkingTime = {
                        StartHourId: null,
                        EndHourId: null,
                        WeekDayId: weekDay.Id,
                        WeekDay: weekDay,
                        UnitId: unitId,
                        Closed: false
                    };

                    vm.workingTimes.push(newWorkingTime);
                }
            }
        }

        // Unit data
        function getUnit() {
            const unitId = AuthenticationService.getSelectedUnit().Id;

            if (!unitId) {
                sweetAlert.swal({
                    title: 'Não foi possível recuperar os dados da loja!',
                    text: 'Ocorreu um erro ao buscar o identificador da loja.',
                    type: 'warning',
                    confirmButtonText: 'Ir para Home',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        HelperService.stopLoading('.loading-holder');

                        $state.go('app.home');
                    }
                })

                return;
            }

            UnitService
                .get(unitId)
                .then(success => {
                    if (success.OpeningDate)
                        success.FormattedOpeningDate = moment(success.OpeningDate).format('DD/MM/YYYY HH:mm:ss');
                    else
                        success.FormattedOpeningDate = 'N/D';

                    if (success.RegistrationDate)
                        success.FormattedRegistrationDate = moment(success.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');
                    else
                        success.FormattedRegistrationDate = 'N/D';

                    if (success.UpdateDate)
                        success.FormattedUpdateDate = moment(success.UpdateDate).format('DD/MM/YYYY HH:mm:ss');
                    else
                        success.FormattedUpdateDate = 'N/D';

                    vm.unitData = success;
                    vm.unitData.UnitImage = Array.isArray(vm.unitData.UnitImage) ? vm.unitData.UnitImage : [];

                    if (success.Unit_Address.length) {
                        vm.unitData.Address = success.Unit_Address[0].Address;
                        vm.selectedState = vm.states.find(state => (state.Id == vm.unitData.Address.City.StateId)) || 'N/D';

                        vm.getCities(vm.unitData.Address.City.Id);
                    }

                    if (vm.unitData.ClusterId)
                        vm.selectedCluster = vm.clusters.find(cluster => (cluster.Id == vm.unitData.ClusterId)) || 'N/D';

                    if (vm.unitData.EconomicGroupId)
                        vm.selectedEconomicGroup = vm.economicGroups.find(group => (group.Id == vm.unitData.EconomicGroupId)) || 'N/D';

                    if (vm.unitData.StatusId)
                        vm.selectedStatus = vm.status.find(status => (status.Id == vm.unitData.StatusId)) || 'N/D';

                    if (vm.unitData.ConsultantPersonId)
                        vm.selectedConsultant = vm.consultants.find(consultant => (consultant.Id == vm.unitData.ConsultantPersonId)) || 'N/D';

                    if (vm.unitData.UnitTypeId)
                        vm.selectedType = vm.types.find(type => (type.Id == vm.unitData.UnitTypeId)) || 'N/D';

                    if (vm.unitData.UnitImage.length) {
                        let unitMainImage = vm.unitData.UnitImage.find(image => (image.Main));

                        if (unitMainImage) {
                            vm.mainImageData = unitMainImage;
                            vm.mainImageData.Display = HelperService.imageHandlerPath('unit', vm.unitData.Id, unitMainImage.Url);
                        }

                        vm.unitGallery = vm.unitData.UnitImage
                            .filter(image => (!image.Main))
                            .reduce((acc, cur) => {
                                cur.fullPath = HelperService.imageHandlerPath('unit', vm.unitData.Id, cur.Url);

                                acc.push(cur);

                                return acc;
                            }, []);
                    }

                    vm.unitData.EcommerceSubsellerId = vm.unitData.EcommerceSubsellerId || 'N/D';
                    vm.unitData.EcommerceGetNetStatus = vm.unitData.EcommerceGetNetStatus || 'N/D';

                    if (vm.unitData.EcommerceAcceptanceDate != null)
                        vm.unitData.EcommerceAcceptanceDate = moment(vm.unitData.EcommerceAcceptanceDate).format('DD/MM/YYYY HH:mm:ss')
                    else
                        vm.unitData.EcommerceAcceptanceDate = 'N/D';

                    vm.workingTimes = vm.unitData.UnitOperation;

                    prepareWorkingTimeWeek();

                    unitOriginalWorkingTime = angular.copy(vm.workingTimes);

                    vm.unitGatewayStatus = vm.unitData.UnitBraspagStatus[0] || {};

                    if (vm.unitGatewayStatus.RegistrationDate != null)
                        vm.unitGatewayStatus.RegistrationDate = moment(vm.unitGatewayStatus.RegistrationDate).format('DD/MM/YYYY HH:mm:ss')
                    else
                        vm.unitGatewayStatus.RegistrationDate = 'N/D';

                    if (vm.unitGatewayStatus.UpdateDate != null)
                        vm.unitGatewayStatus.UpdateDate = moment(vm.unitGatewayStatus.UpdateDate).format('DD/MM/YYYY HH:mm:ss')
                    else
                        vm.unitGatewayStatus.UpdateDate = 'N/D';

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                })
        }

        function getClusters() {
            return ClusterService
                .getAll()
                .then(success => {
                    vm.clusters = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getEconomicGroups() {
            return EconomicGroupService
                .getAll()
                .then(success => {
                    vm.economicGroups = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getStatus() {
            return UnitService
                .getStatus()
                .then(success => {
                    vm.status = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getConsultants() {
            return PersonService
                .getConsultants()
                .then(success => {
                    vm.consultants = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getTypes() {
            return UnitService
                .getTypes()
                .then(success => {
                    vm.types = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getStates() {
            return StateService
                .getAll()
                .then(success => {
                    vm.states = success.filter(state => (state.Id != 0));
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function initVars() {
            vm.unitGallery = [];
            vm.selectedTab = 1;
            vm.cityPlaceholder = 'ESCOLHA UM ESTADO';
            vm.workingTimes = [];

            vm.mainImageData = {
                Url: '',
                Display: ''
            }

            vm.weekDays = [{
                Id: 2,
                Day: 'Segunda-feira',
                Class: 'purple'
            }, {
                Id: 3,
                Day: 'Terça-feira',
                Class: 'purple'
            }, {
                Id: 4,
                Day: 'Quarta-feira',
                Class: 'purple'
            }, {
                Id: 5,
                Day: 'Quinta-feira',
                Class: 'purple'
            }, {
                Id: 6,
                Day: 'Sexta-feira',
                Class: 'purple'
            }, {
                Id: 7,
                Day: 'Sábado',
                Class: 'orange'
            }, {
                Id: 1,
                Day: 'Domingo',
                Class: 'orange'
            }]

            vm.flowOptionsMain = {
                query: () => {
                    return {
                        Path: `unit/${vm.unitData.Id}`,
                        OldImage: vm.oldFormImageMain,
                        CreateThumb: false,
                        CreateThumbAdmin: false
                    }
                }
            }

            vm.flowOptionsGallery = {
                query: () => {
                    return {
                        Path: `unit/${vm.unitData.Id}`,
                        CreateThumb: false,
                        CreateThumbAdmin: false
                    }
                }
            }

            angular.extend(vm.flowOptionsMain, HelperService.getFlowOptionsDefaults());
            angular.extend(vm.flowOptionsGallery, HelperService.getFlowOptionsDefaultsGallery());
        }

        function init() {
            HelperService.startLoading('.loading-holder');

            initVars();

            $q.all([getHours(), getStates(), getClusters(), getEconomicGroups(), getStatus(), getConsultants(), getTypes()])
                .then(() => {
                    getUnit();
                })
        }
    }
}());
